export const getPolicyNumberTitle = (data) => {
  if (data?.product?.type?.toUpperCase().startsWith("A")) return "Contract #";
  return "Contract#";
};
